import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IgxNumberSummaryOperand, IgxSummaryOperand, IgxSummaryResult } from '@infragistics/igniteui-angular';
import { Kid } from 'src/app/models/kid';
import { Package } from 'src/app/models/package';
import { Participation } from 'src/app/models/participation';
import { KidService } from 'src/app/services/kid.service';
import { WaitIndicatorService } from 'src/app/services/wait-indicator.service';

class SumSummary {
    public operate(data?: any[]): IgxSummaryResult[] {
        if (!data) return [];
        const result = [];
        result.push({
            key: 'sum',
            label: 'Sum',
            summaryResult: IgxNumberSummaryOperand.sum(data)
        });
        return result;
    }
}
@Component({
    selector: 'app-info-kid',
    templateUrl: './info-kid.component.html',
    styleUrls: ['./info-kid.component.scss']
})
export class InfoKidComponent {
    private _kid?: Kid;

    public sumSummary = SumSummary;
    public get kid(): Kid | undefined {
        return this._kid;
    }
    @Input()
    public set kid(v: Kid | undefined) {
        this._kid = v;
        if (this.kid && this.kid.id) {
            this.load(this.kid.id);
        }
    }

    @Output() public done = new EventEmitter();

    public sortPackages(): Package[] {
        if (!this.kid || this.kid.packages?.length < 1) return [];
        return this.kid.packages
            .sort((a, b) => this.sortParticipations(a)[0]?.date?.getTime() - this.sortParticipations(b)[0]?.date?.getTime());
    }

    public getPeriod(p: Package): string {
        if (p.participations.length < 1) return 'Няма записани дати!';
        const orderedParticipations = this.sortParticipations(p);
        const options: Intl.DateTimeFormatOptions = { dateStyle: 'short' };
        const start = orderedParticipations[0]?.date?.toLocaleDateString('bg-BG', options);
        const end = orderedParticipations[orderedParticipations.length - 1]?.date?.toLocaleDateString('bg-BG', options);
        return `${start} - ${end}`;
    }

    public sortParticipations(p: Package): Participation[] {
        return p.participations.sort((a, b) => a?.date?.getTime() - b?.date?.getTime())
    }

    public getSport(id: string): string {
        const _package = this.kid?.packages.find(p => p.id === id);
        let sport = _package?.period?.sports?.map(s => s.name)?.join(', ');
        if (!sport) {
            sport = 'Всички спортове';
        }
        return sport;
    }

    public getLevel(id: string): string {
        const _package = this.kid?.packages.find(p => p.id === id);
        let level = _package?.period?.levels?.map(l => l.name)?.join(', ');
        if (!level) {
            level = 'Всички нива';
        }
        return level;
    }

    public formatCurrency(summary: IgxSummaryResult, summaryOperand: IgxSummaryOperand): string {
        const result = summary.summaryResult;
        return result.toLocaleString('bg-BG', { currency: 'BGN', style: 'currency' });
    }

    public constructor(
        private kidService: KidService,
        private wait: WaitIndicatorService,
    ) {}

    private load = async(id: string) => {
        this.wait.show();
        this._kid = await this.kidService.kidInfo(id);
        this.wait.hide();
    }
}
